


































import { Component, Provide, Watch, Prop, Mixins } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw/index';
// Components
import PatientAcquisitionConditions from '@/components/patients/acquisition/PatientAcquisitionConditions.vue';
import ChartRawGaugeSections from '@/components/charts/walking/ChartRawGaugeSections.vue';
import ChartRawGaugeSlider from '@/components/charts/walking/ChartRawGaugeSlider.vue';

@Component({
  components: {
    ChartRawGaugeSections,
    ChartRawGaugeSlider,
    PatientAcquisitionConditions,
  },
})
export default class ChartRawWalkingBanner extends Mixins(MixinChartRaw) {
  get cadence() {
    const val =
      (this.values.computed_data.left.aggregates.step_by_step_cadence.avg * 2 +
        this.values.computed_data.right.aggregates.step_by_step_cadence.avg * 2) /
      2;
    return {
      name: 'cadence',
      value: val,
      ranges: this.$pdc.helper!.refint.getRange(
        this.patient!.infos.gender,
        this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
        'GENERAL',
        'cadence',
        'abs',
      ),
      unit: `${this.$t('commons.units.steps').toString().slice(0, 1)}/min`,
      roundedValue: true,
    };
  }
  get speed() {
    const val =
      (this.$pdc.helper!.mpsToKmh(this.values.computed_data.left.aggregates.walking_speed.avg) +
        this.$pdc.helper!.mpsToKmh(this.values.computed_data.right.aggregates.walking_speed.avg)) /
      2;
    return {
      name: 'speed',
      value: val,
      ranges: this.$pdc.helper!.refint.getRange(
        this.patient!.infos.gender,
        this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
        'GENERAL',
        'speed',
        'abs',
      ),
      unit: 'km/h',
      roundedValue: false,
    };
  }
  get symmetry() {
    const val =
      (1 -
        Math.abs(
          this.values.computed_data.left.aggregates.swing_time.avg /
            this.values.computed_data.left.aggregates.stance_time.avg -
            this.values.computed_data.right.aggregates.swing_time.avg /
              this.values.computed_data.right.aggregates.stance_time.avg,
        ) /
          Math.max(
            this.values.computed_data.left.aggregates.swing_time.avg /
              this.values.computed_data.left.aggregates.stance_time.avg,
            this.values.computed_data.right.aggregates.swing_time.avg /
              this.values.computed_data.right.aggregates.stance_time.avg,
          )) *
      100;
    return {
      name: 'symmetry',
      value: parseFloat(val.toFixed(0)),
    };
  }
}
